"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _deprecate = require("@nerdwallet/deprecate");

var _useIconProps = require("../useIconProps");

var Linkedin = function Linkedin(props) {
  (0, _deprecate.useDeprecatedComponentWarning)({
    component: 'Linkedin'
  });
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 2048 2048"
  }, (0, _useIconProps.useIconProps)(props)), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43 725h426v1323H43V725zm1109 1323v-768q0-123 67.5-189.5T1389 1024q103 0 167.5 73.5T1621 1323v725h427v-768q0-282-141-439.5T1536 683q-122 0-219 61t-165 164l-14-183H718l7 299v1024h427zM254 512h-3q-111 0-181-67.5T0 277q0-101 71.5-167.5T258 43q113 0 182.5 66.5T512 277q0 101-71 168t-187 67z"
  }));
};

Linkedin.displayName = 'Linkedin';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Linkedin.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

var _default = Linkedin;
exports.default = _default;